import { motion, useReducedMotion } from "framer-motion";

const nodes = [
  { x: 60, y: 300, c: "#C9A227" },
  { x: 150, y: 240, c: "#A87B1F" },
  { x: 240, y: 265, c: "#C9A227" },
  { x: 330, y: 180, c: "#A87B1F" },
  { x: 410, y: 120, c: "#0B1F3A" },
  { x: 190, y: 140, c: "#C9A227" },
  { x: 300, y: 70, c: "#A87B1F" },
];

const edges = [[0, 1], [1, 2], [2, 3], [3, 4], [1, 5], [5, 6], [6, 3], [5, 2]];

// One shared loop period: draw in, hold, redraw — forever.
const CYCLE = { duration: 3, repeat: Infinity, repeatDelay: 1.6, ease: "easeInOut" };

export default function HeroVisual() {
  const reduce = useReducedMotion();
  return (
    <div className="relative" data-testid="hero-visual" aria-hidden="true">
      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative overflow-hidden rounded-2xl border border-[#0B1F3A]/10 bg-gradient-to-br from-[#F5F8FC] to-white p-6 shadow-[0_24px_60px_-24px_rgba(11,31,58,0.25)]"
      >
        <div className="absolute inset-0 opacity-[0.5]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(21,101,192,0.18) 1px, transparent 0)", backgroundSize: "26px 26px" }} />
        <svg viewBox="0 0 460 360" className="relative w-full">
          {edges.map(([a, b], i) => (
            <motion.line
              key={i}
              x1={nodes[a].x} y1={nodes[a].y} x2={nodes[b].x} y2={nodes[b].y}
              stroke="#A87B1F" strokeOpacity="0.35" strokeWidth="1.5"
              initial={{ pathLength: 0 }}
              animate={reduce ? { pathLength: 1 } : { pathLength: [0, 1, 1] }}
              transition={
                reduce
                  ? { duration: 1.1, delay: 0.4 + i * 0.12 }
                  : { ...CYCLE, delay: 0.4 + i * 0.12, times: [0, 0.45, 1] }
              }
            />
          ))}
          <motion.polyline
            points="60,300 150,240 240,265 330,180 410,120"
            fill="none" stroke="#0B1F3A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={reduce ? { pathLength: 1 } : { pathLength: [0, 1, 1] }}
            transition={reduce ? { duration: 1.6, delay: 0.8, ease: "easeInOut" } : { ...CYCLE, delay: 0.8, times: [0, 0.55, 1] }}
          />
          {nodes.map((n, i) => (
            <g key={i}>
              <circle cx={n.x} cy={n.y} r="14" fill={n.c} opacity="0.12" className={reduce ? "" : "ic-pulse"} style={{ animationDelay: `${i * 0.35}s` }} />
              <motion.circle
                cx={n.x} cy={n.y} fill={n.c}
                initial={{ r: 0 }}
                animate={reduce ? { r: 5.5 } : { r: [0, 5.5, 5.5] }}
                transition={
                  reduce
                    ? { delay: 0.3 + i * 0.14, type: "spring", stiffness: 260, damping: 14 }
                    : { ...CYCLE, delay: 0.3 + i * 0.14, times: [0, 0.22, 1] }
                }
              />
            </g>
          ))}
        </svg>
        <motion.div
          animate={reduce ? {} : { y: [0, -8, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-5 left-5 rounded-full border border-[#0B1F3A]/10 bg-white/95 px-4 py-2 shadow-lg backdrop-blur"
          data-testid="hero-floating-metric"
        >
          <span className="text-[11px] font-semibold tracking-wide text-[#0B1F3A]">
            Delivery → PMO → Resourcing → Training → <span className="text-[#A87B1F]">Review</span>
          </span>
        </motion.div>
      </motion.div>
    </div>
  );
}
